import { autoinject } from 'aurelia-framework';
import { Router, RouterConfiguration} from 'aurelia-router';
import { State } from '../services/global-state';

@autoinject
export class SecureSite {
	globalState: State;
	router: Router;

	constructor(state: State) {
		this.globalState = state;
	}

	configureRouter(config: RouterConfiguration, router: Router): void {
		config.map([
			{ route: '', name: 'dashboard', moduleId: './customer-dashboard/customer-dashboard-index', title: 'dashboard', nav: true, settings: { fallbackText: 'Dashboard', dataTest: 'side-menu-dashboard' } },
			{ route: 'preferences', name: 'preferences', moduleId: './preferences/preferences', title: 'preferences', nav: false, settings: { fallbackText: 'Preferences' } },
			{ route: 'securitySettings', name: 'securitySettings', moduleId: './security-settings/security-settings', title: 'Security Information', nav: false, settings: { fallbackText: 'Security Settings' } },
			{ route: 'myWallet', name: 'myWallet', moduleId: './my-wallet/my-wallet', title: 'myWallet', nav: false, settings: { fallbackText: 'Wallet' } },
			{ route: 'addRemoveCustomer', name: 'addRemoveCustomer', moduleId: './add-remove-customer/add-remove-customer', title: 'addRemoveCustomer', nav: false, settings: { fallbackText: 'Add/Remove Customer' } },
			{ route: 'addCustomerNotificationPreferences', name: 'addCustomerNotificationPreferences', moduleId: './add-customer-notification-preferences/add-customer-notification-preferences', title: 'addCustomerNotificationPreferences', nav: false, settings: { fallbackText: 'Add Customer Notification Preferences' } },
			{ route: 'messages', name: 'messages', moduleId: './messages/messages', title: 'messages', nav: false, settings: { fallbackText: 'Messages' } },
			{ route: 'addPaymentMethod', name: 'addPaymentMethod', moduleId: './my-wallet/add-payment-method/add-payment-method', title: 'Add Payment Method', nav: false },
			{ route: 'editPaymentMethod', name: 'editPaymentMethod', moduleId: './my-wallet/add-payment-method/add-payment-method', title: 'Edit Payment Method', nav: false },
			{ route: 'verification', name: 'verification', moduleId: './login-register/sms-verification/sms-verification', title: 'verification', nav: false },
			{ route: 'setupPrimaryPaymentMethod', name: 'setupPrimaryPaymentMethod', moduleId: './login-register/setup-primary-payment-method/setup-primary-payment-method', title: 'Setup Primary Payment Method', nav: false },

			// installments
			{
				route: 'installments/:id/select-option',
				name: 'installments/select-option',
				moduleId: './installments/installments-select-option/installments-select-option',
				title: 'Select Installment Plan',
				nav: false
			},
			{
				route: 'installments/:id/view',
				name: 'installments/view-installments',
				moduleId: './installments/view-installments',
				title: 'View Installments'
			},
			{
				route: 'installments/:id/setup-payment-plan/',
				name: 'installments/setup-payment-plan',
				moduleId: './installments/setup-installment',
				title: 'Setup Installment Payment Plan'
			},
			{
				route: 'installments/:id/installment-receipt/',
				name: 'installments/installment-receipt',
				moduleId: './installments/installment-receipt',
				title: 'installment Receipt'
			},
			{
				route: 'installments/:id/cancel',
				name: 'installments/cancel-installments',
				moduleId: './installments/cancel-installments',
				title: 'Cancel Installments',
				nav: false
			},

			// recurring
			{
				route: 'recurring/:id/setup-payment-plan/',
				name: 'recurring/setup-payment-plan',
				moduleId: './recurring/setup-recurring',
				title: 'Setup Recurring Payment Plan'
			},
			{
				route: 'recurring/:id/recurring-receipt/',
				name: 'recurring/recurring-receipt',
				moduleId: './recurring/recurring-receipt',
				title: 'Recurring Receipt'
			},
			{
				route: 'recurring/:id/view',
				name: 'recurring/view-recurring',
				moduleId: './recurring/view-recurring',
				title: 'View Recurring'
			},

			// single payment
			{
				route: 'single-payment',
				name: 'single-payment/single-payment',
				moduleId: './single-payment/single-payment',
				title: 'Make a Payment'
			},
			{
				route: 'single-payment/receipt',
				name: 'single-payment/single-payment-receipt',
				moduleId: './single-payment/single-payment-receipt',
				title: 'Transaction Receipt'
			},

			// autopay
			{
				route: 'autopay/:id/view',
				name: 'autopay/view-autopay',
				moduleId: './autopay/view-autopay',
				title: 'View Autopay'
			},
			{
				route: 'autopay/:id/edit',
				name: 'autopay/edit-autopay',
				moduleId: './autopay/edit-autopay',
				title: 'Edit Autopay'
			},
			{
				route: 'autopay/:id/receipt',
				name: 'autopay/autopay-receipt',
				moduleId: './autopay/autopay-receipt',
				title: 'Autopay Receipt'
			},
			{
				route: 'autopay/:id/setup',
				name: 'autopay/setup-autopay',
				moduleId: './autopay/setup-autopay',
				title: 'Setup and Review Autopay'
			},

			// dashboard
			{
				route: 'docs',
				name: 'docs',
				moduleId: './my-documents/my-documents',
				title: 'myDocs',
				nav: true,
				settings: {
					fallbackText: 'My Docs',
					dataTest: 'side-menu-my-docs'
				},
			},
			{
				route: 'payment-history',
				name: 'paymentHistory',
				moduleId: 'pages/payment-history/payment-history',
				title: 'paymentHistory',
				nav: true,
				settings: {
					fallbackText: 'Payment History',
					dataTest: 'side-menu-payment-history'
				},
			},
			{
				route: 'payment-history/receipt',
				name: 'paymentHistoryReceipt',
				moduleId: 'pages/payment-history/payment-history-receipt',
				title: 'paymentHistoryReceipt',
				nav: false
			},
			{
				route: 'scheduled-payments',
				name: 'scheduledPayments',
				moduleId: 'pages/scheduled-payments/scheduled-payments',
				title: 'scheduledPayments',
				nav: true,
				settings: {
					fallbackText: 'Scheduled Payments',
					dataTest: 'side-menu-scheduled-payments'
				},
			},
			{
				route: 'scheduled-payments/cancel-single-future',
				name: 'scheduled-payments/cancel-single-future',
				moduleId: 'pages/scheduled-payments/cancel-single-future',
				title: 'cancelSingleFuture',
				nav: false
			},
			{
				route: 'skip-plan-payments/skip-plan-payments',
				name: 'skipPlanPayments',
				moduleId: 'pages/skip-plan-payments/skip-plan-payments',
				title: 'skipPlanPayments',
				nav: false
			},
			{
				route: 'negotiator/:id',
				name: 'negotiator',
				moduleId: 'pages/negotiator/negotiator',
				title: 'negotiator',
				nav: false
			},
			{
				route: 'contact-me',
				name: 'contactMe',
				moduleId: 'pages/contact-me/contact-me',
				title: 'contactMe',
				nav: false
			}

		]);

		this.router = router;
		config.fallbackRoute('dashboard');
	}

	attached(): void {
		if (!this.globalState.accounts) {
			this.router.navigateToRoute('login');
		}
	}
}
